import React, { ReactNode } from "react";

interface ReleaseNoteProps {
  tag?: "new" | "improved" | "fixed" | "breaking";
  title: string;
  children: ReactNode;
}

export const ReleaseNote: React.FC<ReleaseNoteProps> = ({
  tag = "new",
  title,
  children,
}) => {
  return (
    <div className="releasenote">
      <div className="releasenote__tag">
        <span className={`relbadge relbadge--${tag}`}>{tag}</span>
      </div>
      <div className="releasenote__body">
        <h3>{title}</h3>
        {typeof children === "string" ? <p>{children}</p> : children}
      </div>
    </div>
  );
};
